import React, { useState, useEffect } from "react";
import api from "../../../../api";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import "./OutreachActivities.css";

import DynamicBanner from "../../include/DynamicBanner";

const OutreachActivities = () => {
  const [showMore, setShowMore] = useState(false);
  const [showMoreDesktop, setShowMoreDesktop] = useState(false);
  const [csrData, setCsrData] = useState(null);
  const [expandedCardIndex, setExpandedCardIndex] = useState(null);

  const toggleReadMore = () => setShowMore((s) => !s);
  const toggleReadMoreDesktop = () => setShowMoreDesktop((s) => !s);

  const handleCardToggle = (index) => {
    setExpandedCardIndex(expandedCardIndex === index ? null : index);
  };

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await api.get("/api/sitepages/outreach-activities");

        let bannerSection = response?.data?.groups?.[0]?.banner_section || {};
        let aboutSection = response?.data?.groups?.[1]?.about_section || {};
        let cardsSection = response?.data?.groups?.[2]?.cards_section || {};

        // Normalize about_content to array of paragraphs
        if (aboutSection.about_content && typeof aboutSection.about_content === "object") {
          aboutSection.about_content = Object.values(aboutSection.about_content);
        }

        let cards = [];
        if (typeof cardsSection.cards === "string") {
          try {
            cards = JSON.parse(cardsSection.cards);
          } catch (e) {
            console.error("Invalid cards JSON", e);
          }
        }

        setCsrData({ bannerSection, aboutSection, cards });
      } catch (error) {
        console.error("Error fetching CSR data:", error);
      }
    };
    fetchConfig();
  }, []);

  if (!csrData) return null;
  const { bannerSection, aboutSection } = csrData;
  const cards = csrData.cards || [];

  const bannerSwiperSettings = {
    modules: [Autoplay, Pagination],
    speed: 800,
    slidesPerView: 1,
    spaceBetween: 10,
    pagination: false,
  };

  const cardSwiperSettings = {
    modules: [Autoplay],
    spaceBetween: 20,
    loop: true,
    autoplay: { delay: 3000, disableOnInteraction: false },
    breakpoints: {
      0: { slidesPerView: 1 },
      768: { slidesPerView: 2 },
      992: { slidesPerView: 3 },
    },
  };

  // Only show Read More if there is more than one paragraph
  const hasReadMoreContent =
    Array.isArray(aboutSection?.about_content) &&
    aboutSection.about_content.length > 1;

  // Utility to safely render paragraph HTML or plain text (preserve newlines)
  const renderParagraphHtml = (para) => {
    if (!para) return { __html: "" };
    // if it already contains HTML tags, trust it
    if (/<\/?[a-z][\s\S]*>/i.test(para)) {
      return { __html: para };
    }
    // else convert newlines to <br/>
    const html = para.replace(/\r\n|\n/g, "<br/>");
    return { __html: html };
  };

  // If about_content isn't an array, coerce to empty array
  const aboutParas = Array.isArray(aboutSection?.about_content)
    ? aboutSection.about_content
    : [];
    const desktopBannerImages =
  Array.isArray(bannerSection?.images) && bannerSection.images.length > 0
    ? bannerSection.images
    : bannerSection?.image
    ? [bannerSection.image]
    : [];

const mobileBannerImages =
  Array.isArray(bannerSection?.mobile_images) && bannerSection.mobile_images.length > 0
    ? bannerSection.mobile_images
    : [];


  return (
    <>
      {(bannerSection.title || bannerSection.image) && (
         <DynamicBanner
    title={bannerSection.title || ""}
    bgImage={desktopBannerImages}       
    bgImageMobile={mobileBannerImages} 
  />
      )}

      <div className="outreact_activies_section">
        {aboutSection?.title || aboutParas.length ? (
          <section className="pb_80 csr-section">
            <div className="container">
              {aboutSection?.title && (
                <div className="sec-title text-center">
                  <h2>{aboutSection.title}</h2>
                </div>
              )}

              {/* Desktop View */}
              <div style={{ textAlign: "justify" }} className="d-none d-md-block">
                <div className="row d-flex justify-content-center align-items-center">
                  <div className="col-md-7 col-12">
                    <div className="outreach-content">
                      {/* Show only first paragraph by default */}
                      {aboutParas[0] && (
                        <p dangerouslySetInnerHTML={renderParagraphHtml(aboutParas[0])} />
                      )}

                      {/* Rest of paragraphs shown only when toggled */}
                      {showMoreDesktop &&
                        aboutParas.slice(1).map((para, i) => (
                          <p key={i} dangerouslySetInnerHTML={renderParagraphHtml(para)} />
                        ))}

                      {/* Only show button if more than 1 paragraph */}
                      {hasReadMoreContent && aboutSection?.readMore_btn && (
                        <button className="readmoreall" onClick={toggleReadMoreDesktop}>
                          {showMoreDesktop ? aboutSection.readLess_btn : aboutSection.readMore_btn}
                        </button>
                      )}
                    </div>
                  </div>

                  {/* Desktop Swiper */}
                  {aboutSection?.swiper_image?.length > 0 && (
                    <div className="col-md-5 col-12">
                      <Swiper {...bannerSwiperSettings} className="banner-swiper">
                        {aboutSection.swiper_image.map((src, index) => (
                          <SwiperSlide key={index}>
                            <img src={`${process.env.REACT_APP_API_URL}/public${src}`} alt={`Slide ${index + 1}`} />
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </div>
                  )}
                </div>
              </div>

              {/* Mobile View */}
              <div style={{ textAlign: "justify" }} className="d-block d-md-none">
                <div className="row">
                  <div className="col-12">
                    {/* Show only first paragraph by default */}
                    {aboutParas[0] && (
                      <p dangerouslySetInnerHTML={renderParagraphHtml(aboutParas[0])} />
                    )}

                    {showMore &&
                      aboutParas.slice(1).map((para, i) => (
                        <p key={i} dangerouslySetInnerHTML={renderParagraphHtml(para)} />
                      ))}

                    {/* Only show button if more than 1 paragraph */}
                    {hasReadMoreContent && aboutSection?.readMore_btn && (
                      <button className="readmoreall mb-3" onClick={toggleReadMore}>
                        {showMore ? aboutSection.readLess_btn : aboutSection.readMore_btn}
                      </button>
                    )}
                  </div>

                  {/* Mobile Swiper */}
                  {aboutSection?.swiper_image?.length > 0 && (
                    <div className="col-12">
                      <Swiper {...bannerSwiperSettings} className="banner-swiper">
                        {aboutSection.swiper_image.map((src, index) => (
                          <SwiperSlide key={index}>
                            <img src={`${process.env.REACT_APP_API_URL}/public${src}`} alt={`Slide ${index + 1}`} />
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
        ) : null}

        {/* Image Cards Section */}
        {cards.length > 0 && (
          <section className="pb_80 pt_80" style={{ background: "aliceblue" }}>
            <div className="container">
              <Swiper {...cardSwiperSettings} className="outreach-carousel">
                {cards.map((card, index) => {
                  const colorType = index % 2 === 0 ? "light-blue" : "dark-blue";

                  return (
                    <SwiperSlide key={index}>
                      <div className="item text-center">
                        {/* Image */}
                        <div className={`image-container-csr ${colorType}-hover`}>
                          <img
                            src={`${process.env.REACT_APP_API_URL}/public${card.img}`}
                            alt="Outreach"
                            className="slide-image"
                          />
                          <div className={`overlay ${colorType === "light-blue" ? "" : "overlay1"}`}></div>
                        </div>

                        {/* Text */}
                        <div
                          className={`content-csr ${colorType}-csr ${
                            expandedCardIndex === index ? "expanded" : ""
                          } text-white p-3`}
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                expandedCardIndex === index
                                  ? card.text
                                  : (card.text ? card.text.replace(/<[^>]+>/g, "").slice(0, 200) + (card.text.length > 200 ? "..." : "") : ""),
                            }}
                          />

                          <div className="text-center">
                            <span
                              className="view-more-btn"
                              onClick={() => handleCardToggle(index)}
                            >
                              {expandedCardIndex === index ? "View Less" : "View More"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
          </section>
        )}
      </div>
    </>
  );
};

export default OutreachActivities;
